import { General } from '../General';

export class AuthorizationAPI {
    private static _basePath = General.getAuthorizationUrl();

    static getMethods() {
        return {};
    }
}
